import React from 'react';
import "./ImageViewer.css";

const getFileData = (file) => {
   if (typeof file === 'string') {
      return file
   };

   var binaryData = [];
   binaryData.push(file);
   return URL.createObjectURL(new Blob(binaryData))
};

const ImageViewer = ({ src, className, alt = "", ...others }) => {
   return (
      <div className='ImageViewerDiv h-100'>
         <img src={getFileData(src)} className={className} alt={alt} {...others} />
      </div>
   )
}

export default ImageViewer;